import Immutable from 'immutable';

import { safeIdEncode } from 'sharedreact/utils/Encode';

const IDNameDomainSeparator = '__separator__';

const Content: {
  id: string,
  name: string,
  domain: string,
  fullName: string,
  description: string,
  email: string,
  role: string,
  userType: string,
  managed: boolean
} = {
  id: '',
  name: '',
  domain: '',
  fullName: '',
  description: '',
  email: '',
  role: '',
  userType: '',
  managed: false
};

class User extends Immutable.Record(Content) {
  static createTemp (): User {
    return new User();
  }

  static fromJS (json: object): User {
    return new User(Immutable.fromJS(json));
  }

  static get Roles () {
    // ESnext class fields are just a stage 3 TC39 proposal right now
    // (see https://github.com/tc39/proposal-class-fields). In the
    // meantime, we'll use a static getter instead.
    return Immutable.List(['user', 'admin']);
  }

  static toRoleName (role: string): string {
    switch (role) {
      case 'admin': {
        return 'shared.user.role.administrator';
      }
      case 'user': {
        return 'shared.user.role.user';
      }
      default: {
        return role;
      }
    }
  }

  get nameAtDomain (): string {
    if (this.domain === '' || this.name.indexOf('@') > 0) {
      return this.name;
    }
    return this.name + '@' + this.domain;
  }

  isAllowedToSeeView (view: string) {
    return (this.role === 'admin' || !view.startsWith('workflowkits.view.admin.'));
  }

  get userInfoId (): string {
    const id = this.name.split('@')[0].concat(IDNameDomainSeparator).concat(this.domain.toLowerCase());
    return safeIdEncode(id);
  }

  isAdmin (): boolean {
    return this.role === 'admin';
  }
}

export default User;
